import { isAssetConvertibleForBulkCopy } from './computeBulkCopySelectionFlags';

/**
 * Central rendition-support summary for a selection of assets. Copy/Download
 * conversion flows use it to decide whether unsupported formats (e.g. `.obj`)
 * should fully disable the Custom/conversion controls or just surface a
 * non-blocking warning while supported assets keep their renditions.
 *
 * @param {Object[]} assets
 * @returns {{
 *   total: number,
 *   supportedCount: number,
 *   unsupportedCount: number,
 *   hasUnsupported: boolean,
 *   hasSupported: boolean,
 *   allUnsupported: boolean,
 * }}
 */
export default function getRenditionSupportSummary(assets) {
  const list = Array.isArray(assets) ? assets.filter(Boolean) : [];
  const total = list.length;
  const supportedCount = list.filter(isAssetConvertibleForBulkCopy).length;
  const unsupportedCount = total - supportedCount;

  return {
    total,
    supportedCount,
    unsupportedCount,
    hasUnsupported: unsupportedCount > 0,
    hasSupported: supportedCount > 0,
    allUnsupported: total > 0 && supportedCount === 0,
  };
}
